var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hot-products"},[_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.brand_discription))]),_vm._v(" "),_c('v-product-list'),_vm._v(" "),_c('infinite-loading',{ref:"infiniteLoading",on:{"infinite":_vm.indexProductsData}},[_c('span',[_vm._v("\n\t\t\t\t暂无更多数据！\n\t\t\t")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52b72da0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_hotProducts/index_hotProducts.vue
// module id = null
// module chunks = 